'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dOystr$002dAdmin$002dPage$0024 from "./presto.-Oystr-Admin-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002489 from "./presto.-Presto-Router$$anon$89.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$88() {
  this.boS = null;
  this.boK = null;
  this.boL = false;
  this.boT = null;
  this.boU = false;
  this.boX = null;
  this.boQ = null;
  this.boR = false;
  this.boM = null;
  this.boN = false;
  this.boO = null;
  this.boP = false;
  this.boV = false;
  this.boW = false;
  this.boS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.boX = "OystrAdminPage";
}
export { $c_Lpresto_PrestoRouter$$anon$88 as $c_Lpresto_PrestoRouter$$anon$88 };
$p = $c_Lpresto_PrestoRouter$$anon$88.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$88;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$88() {
}
export { $h_Lpresto_PrestoRouter$$anon$88 as $h_Lpresto_PrestoRouter$$anon$88 };
$h_Lpresto_PrestoRouter$$anon$88.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.boS;
});
$p.L = (function() {
  if ((!this.boL)) {
    this.boK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.boL = true;
  }
  return this.boK;
});
$p.O = (function() {
  if ((!this.boU)) {
    this.boT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.boU = true;
  }
  return this.boT;
});
$p.E = (function() {
  return this.boX;
});
$p.t = (function() {
  if ((!this.boR)) {
    this.boQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boR = true;
  }
  return this.boQ;
});
$p.M = (function() {
  if ((!this.boN)) {
    this.boM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boN = true;
  }
  return this.boM;
});
$p.Q = (function() {
  if ((!this.boP)) {
    this.boO = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002489.$c_Lpresto_PrestoRouter$$anon$89();
    this.boP = true;
  }
  return this.boO;
});
$p.w = (function() {
  if ((!this.boW)) {
    this.boV = false;
    this.boW = true;
  }
  return this.boV;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee563) => ((p) => \u03b4scrutinee563))($j_presto$002e$002dOystr$002dAdmin$002dPage$0024.$m_Lpresto_OystrAdminPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$88 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$88, "presto.PrestoRouter$$anon$88", ({
  OX: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$88 as $d_Lpresto_PrestoRouter$$anon$88 };
//# sourceMappingURL=presto.-Presto-Router$$anon$88.js.map
